import * as React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@ellucian/react-design-system/core/es/CircularProgress';
import { withStyles } from '@ellucian/react-design-system/core/es/styles';
import { fountain100 } from '@ellucian/react-design-system/core/es/styles/tokens';
import { TOKEN } from './Configuration';

const styles = () => ({
  overlayDisable: {
    backgroundColor: fountain100,
    position: TOKEN.fixed,
    width: TOKEN.size.maximum,
    height: TOKEN.size.maximum,
    zIndex: '1000',
    top: TOKEN.size.size0,
    left: TOKEN.size.size0,
    opacity: '0.5',
  },
  overlay: {
    backgroundColor: TOKEN.colors.transparent,
    position: TOKEN.fixed,
    width: TOKEN.size.maximum,
    height: TOKEN.size.maximum,
    zIndex: '1000',
    top: TOKEN.size.size0,
    left: TOKEN.size.size0,
  },
});

class PageLoadIndicator extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.overlayDisable}>
        </div>
        <div className={classes.overlay}>
          <CircularProgress className="loadingIndicator" />
        </div>
      </div>
    );
  }
}

PageLoadIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PageLoadIndicator);
